import { render, staticRenderFns } from "./DashboardStudents.vue?vue&type=template&id=b72f3be6&scoped=true&"
import script from "./DashboardStudents.vue?vue&type=script&lang=js&"
export * from "./DashboardStudents.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStudents.vue?vue&type=style&index=0&id=b72f3be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f3be6",
  null
  
)

export default component.exports